import { i18n } from '@/i18n'

export default [
  {
    icon: 'bell',
    path: 'notifications',
    name: 'notifications',
    component: () => import('@/views/notifications/Notifications.vue'),
    meta: { registerNavFromMenu: true, status: 99999, title: i18n.t('app.notifications') }
  },
  // {
  //   icon: 'bell',
  //   path: 'notifications/:status',
  //   name: 'notifications/status',
  //   component: () => import('@/views/notifications/Notifications.vue'),
  //   meta: { registerNavFromMenu: true }
  // },
  {
    path: 'notifications/:type/:id/details',
    name: 'notification/details',
    component: () => import('@/views/notifications/Notification.vue'),
    meta: { secondaryMenu: 'notifications', registerNavFromMenu: false, title: i18n.t('app.notification_detail') }
  },
  {
    path: 'notifications/:type/:id/groups',
    name: 'notification/groups',
    component: () => import('@/views/notifications/GroupsByNotification.vue'),
    meta: { secondaryMenu: 'notifications', registerNavFromMenu: false, title: i18n.t('app.groups_link') }
  },
  {
    path: 'notifications/:type/:id/presentations',
    name: 'notification/presentations',
    component: () => import('@/views/notifications/PresentationsAEAT.vue'),
    meta: { secondaryMenu: 'notifications', registerNavFromMenu: false, title: i18n.t('app.presentations_aeat') }
  },
  {
    path: 'notifications/:type/:id/emails',
    name: 'notification/emails',
    component: () => import('@/views/notifications/EmailsByNotification.vue'),
    meta: { secondaryMenu: 'notifications', registerNavFromMenu: false, title: i18n.t('app.emails_link') }
  },
  {
    path: 'notifications/:type/:id/historical',
    name: 'notification/historical',
    component: () => import('@/views/historical/NEOHistorical.vue'),
    meta: { secondaryMenu: 'notifications', registerNavFromMenu: false, title: i18n.t('historical.by_NEO') }
  },
  {
    path: 'notifications/new',
    name: 'notification/new',
    component: () => import('@/views/notifications/NewNotification.vue'),
    meta: { secondaryMenu: 'notifications/new', registerNavFromMenu: false, title: i18n.t('app.new_notification') }
  },
  {
    path: 'notifications/:type/:id/presentations/new',
    name: 'presentation/new',
    component: () => import('@/views/notifications/NewPresentation.vue'),
    meta: { secondaryMenu: 'presentations/new', registerNavFromMenu: false, title: i18n.t('app.new_presentation') }
  }
]
